export default "__VITE_ASSET__NZamIwHV__"